export default __webpack_public_path__ + "static/media/LENS_CULINARIS_OGRE_1.e8a9433c.jpg";